import { render } from "./IconBucket.vue?vue&type=template&id=1f8fccd9"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBucket.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f8fccd9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f8fccd9', __exports__)) {
    api.reload('1f8fccd9', __exports__)
  }
  
  module.hot.accept("./IconBucket.vue?vue&type=template&id=1f8fccd9", () => {
    api.rerender('1f8fccd9', render)
  })

}


export default __exports__